module.exports = __webpack_public_path__ + "components/breakheader/background/background--10-6a14702025b73002506a3b9474a3bc19.jpg";